import { IS_FEDRAMP_ENVIRONMENT } from '@/constants/env'

import { useActiveOrgHasCuiEnabled } from '@/hooks/organization/useActiveOrg'

export const useCanAccessMonitors = () => {
  const { data: cuiEnabled, isLoading } = useActiveOrgHasCuiEnabled()

  return {
    canAccessMonitors: !IS_FEDRAMP_ENVIRONMENT && cuiEnabled === false,
    // An as-yet-unknown CUI flag (active org not present in the loaded org
    // pages) reads as "still loading" so the guard waits instead of
    // hard-redirecting a legitimate non-CUI user. Access is still granted only
    // on an explicit non-CUI (`false`) answer, so a CUI org is never let
    // through while the flag is `undefined`.
    isLoading:
      !IS_FEDRAMP_ENVIRONMENT && (isLoading || cuiEnabled === undefined),
  }
}
